import type {
  AccountDto,
  AccountResponse,
  AccountsResponse,
  CreateAccountBody,
  DeleteAccountResponse,
  ProvisionAccountBody,
  UpdateAccountBody,
} from '../../shared/types/index.js';
import { request } from './client.js';

export async function fetchAccounts(): Promise<Array<AccountDto>> {
  const { accounts } = await request<AccountsResponse>('/accounts');
  return accounts;
}

export async function createAccount(body: CreateAccountBody): Promise<AccountDto> {
  const { account } = await request<AccountResponse>('/accounts', { method: 'POST', body });
  return account;
}

export async function updateAccount(id: string, body: UpdateAccountBody): Promise<AccountDto> {
  const { account } = await request<AccountResponse>(`/accounts/${encodeURIComponent(id)}`, { method: 'PATCH', body });
  return account;
}

/** Deletes the account and retires its provisioned provider user; a linked provider user is left untouched. */
export async function deleteAccount(id: string): Promise<void> {
  await request<DeleteAccountResponse>(`/accounts/${encodeURIComponent(id)}`, { method: 'DELETE' });
}

/** Retries upstream provisioning, or links the account to an existing upstream user. */
export async function provisionAccount(id: string, body: ProvisionAccountBody = {}): Promise<AccountDto> {
  const { account } = await request<AccountResponse>(`/accounts/${encodeURIComponent(id)}/provision`, {
    method: 'POST',
    body,
  });
  return account;
}
